import { Person } from "../models/person.model";

export interface NavState {
  fromScroll?: number;
  toScroll?: number;
}

export interface MembersNavState extends NavState {
  searchText?: string;
  regularized?: boolean;
}

export interface UsersNavState extends NavState {
  searchText?: string;
  regularized?: boolean;
}

export interface AgentsNavState extends NavState {
  searchText?: string;
  sport_id?: number;
}

export enum HammerSwipeAction {
  LEFT = 'swipeleft',
  RIGHT = 'swiperight',
}

export type MobileNavigator = {
  virtualKeyboard: any;
};

export enum Language {
  PT_PT = 'pt-PT',
  EN_US = 'en-US',
}

export enum ChannelType {
  PUSH = 'PUSH',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum DataRawType {
  TEXT = 'text',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
}

export enum DataType {
  TEXT = 'text',
  DATE = 'date',
  LIST = 'list',
  BOOLEAN = 'boolean',
  NUMBER = 'number',
  IMAGE = 'image',
}

export enum VariableType {
  ENTITY    = 'entity',
  COMPOUND  = 'compound',
  GLOBAL    = 'global',
}

export enum VariableTransformation {
  FIRST_WORD = 'firstWord',
  LAST_WORD = 'lastWord',
  MD5 = 'md5',
}

export type VariableMap = {
  [key: string]: Variable[];
};

export type Variable = {
  type: VariableType;
  placeholder: string;
  name?: string;
  entity?: string;
  path?: string;
  transformation?: string;
  value?: string;
};